import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

const createStorage = createStorageCategory('session', 'ONBOARDING')

export const savedRegToken = createStorage('reg_token', v.string())
export const savedUserPoolRegion = createStorage('userPoolRegion', v.string())
export const savedUserPoolId = createStorage('userPoolId', v.string())
export const savedAppClientId = createStorage('appClientId', v.string())
export const savedOrganization = createStorage('organization', v.string())
export const savedEmail = createStorage('email', v.string())
export const savedPhone = createStorage('phone', v.string())
export const savedFirstname = createStorage('firstname', v.string())
export const savedLastname = createStorage('lastname', v.string())
export const savedCountryCode = createStorage('country_code', v.string())
export const savedUsersAmount = createStorage('users_amount', v.string())
export const savedIndustry = createStorage('industry', v.string())
export const savedAllowFeedback = createStorage('allow_feedback', v.boolean())
